// @flow
import React from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { Spinner } from './Spinner';

type Props = {
  height?: number
};

export const Loading = (props: Props) => {
  const height = props.height || '300px';

  return (
    <Flex style={{ height }} justify="center" align="center">
      <Spinner />
    </Flex>
  );
};
